<template>
  <div class="py-14 my-auto">
    <SectionHeader
        :title="`${$store.state.profile.full_name.split(' ')[0]}, Let's get to meet you`"
        subtitle="Kindly take a selfie (we'd love your smile too)"
    />

    <div class="mt-12">
      <Avatar/>
    </div>

    <div class="flex mt-12">
      <AppButton @click="$emit('done')" :disabled="!image">Continue</AppButton>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/global/SectionHeader";
import AppButton from "@/components/global/Button";
import Avatar from "@/components/Avatar";

export default {
  name: 'Picture',
  components: { Avatar, AppButton, SectionHeader },
  computed: {
    image() {
      const { profile_image } = this.$store.state.profile;
      if (profile_image === 'https://res.cloudinary.com/du1mqyww8/image/upload/v1617623098/wnwad3hebiais8ulr5yy.png') return null
      else return profile_image;
    }
  }
};
</script>
